<ng-container *ngIf="searchResult$ | async as searchResult">
  <div class="facet-value d-flex flex-column flex-grow-1">
    <udex-search
      *ngIf="isNeedToShowSearch()"
      [label]="'search.enterKeyword' | cxTranslate"
      mode="Standard"
      show-submit-button
      (handleValueSearch)="onSearchChange($event)"
      (handleValueReset)="onSearchReset()"
      [attr.accessible-name-search-icon]="'search.search' | cxTranslate"
      [attr.accessible-name]="'search.search' | cxTranslate"
      [attr.tooltip-submit-button]="'search.search' | cxTranslate"
      role="Search"
      class="udex-p-12"
    ></udex-search>
    <ng-container *ngFor="let value of filteredFacetValues">
      <udex-list-item
        *ngIf="value?.name?.length"
        mode="MultiSelect"
        [selected]="value.selected"
        [supportingText]="value.description ? value.description : null"
        [disabled]="!facetSearchService.isActiveFacetValue(value, facet.name, searchResult.facets)"
        [label]="value.name"
        (click)="onSelect($event)"
      ></udex-list-item>
    </ng-container>
  </div>
</ng-container>
